import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EarnPointsComponent } from './earn-points.component';
import { EarnPointsCardComponent } from './earn-points-card/earn-points-card.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';

@NgModule({
  declarations: [EarnPointsComponent, EarnPointsCardComponent],
  imports: [
    CommonModule,
    InlineSVGModule,
    NgbModule,
    PipesModule,
    FGBSharedModule
  ],
  exports: [EarnPointsComponent, EarnPointsCardComponent],
})
export class EarnPointsModule {}
